module.exports = __webpack_public_path__ + "static/gem-visa-cards-vertical-51634e9572cb41ceaf2a33ecd26223cc.png";